export default {
  userSettings: [],
  userSetting: undefined,
};
